import * as yup from 'yup';

import { emailSchema, passwordSchema } from './common';

export const logInSchema = yup.object().shape({
  email: emailSchema,
  rememberMe: yup.boolean(),
  password: yup.string().required('*is required'),
});

export const resetPasswordSchema = yup.object().shape({
  email: emailSchema,
});

export const newPasswordSchema = yup.object().shape({
  password: passwordSchema,
  passwordConfirm: yup
    .string()
    .oneOf([yup.ref('password')], '*password do not match')
    .required('*is required')
    .label('confirm password'),
});

export const changePasswordSchema = yup.object().shape({
  currentPassword: yup.string().required('*is required'),
  newPassword: passwordSchema,
  newPasswordConfirm: yup
    .string()
    .oneOf([yup.ref('newPassword')], '*password do not match')
    .required('*is required')
    .label('confirm password'),
});

export const changePasswordAdminSchema = yup.object().shape({
  newPassword: passwordSchema,
  newPasswordConfirm: yup
    .string()
    .oneOf([yup.ref('newPassword')], '*password do not match')
    .required('*is required')
    .label('confirm password'),
});
